import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createLedger: '+ ADD_CARTRULES)

const cartrule_obj = {
    namespaced: true,
    state: {
        cartrule: []
    },
    mutations: {
        LOGOUT_USER (state) {
            state.cartrule = []
        }
    },
    getters: {
        cartrule (state) {
            return state.cartrule
        }
    },
    actions: {
        // API Calls
        async getAllRoudGov ({ dispatch, commit, getters, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('allroundgove')
                //commit(ADD_CARTRULES, response.data)
                console.log('getAllRoudGov: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getCartRuleGovByRound ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                console.log('getCartRuleGovByRound data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('cartrule', {params: {id: data.id, bettype_id: data.bettype_id,}})
                console.log('getCartRuleGovByRound response: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getCartRuleGovByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                console.log('getCartRuleGovByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('cartrule/' + data)
                console.log('getCartRuleGovByRoundId: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default cartrule_obj
